'use client'

import type { GetAllCollectionsOutputDTO } from '@algoacademy/backend/modules/docs/endpoints/queries/get-all-collections/output.dto'
import { Tabs } from '@algoacademy/design-system/web/navigation/Tabs'
import { type Dispatch, type SetStateAction, useState } from 'react'
import { CollectionsGrid } from './CollectionsGrid'

enum COLLECTION_TABS {
  PUBLIC = 'Ogólnodostępne',
  ASSIGNED = 'Dla mnie'
}

type LoggedInCollectionsViewProps = {
  allCollections: GetAllCollectionsOutputDTO['allCollections']
  hasManageAllPermission: boolean
}

export function LoggedInCollectionsView({
  allCollections,
  hasManageAllPermission
}: LoggedInCollectionsViewProps) {
  const [activeTab, setActiveTab] = useState<COLLECTION_TABS>(COLLECTION_TABS.PUBLIC)

  const publicCollections = allCollections.filter(collection => collection.isPublic)

  const collectionsForRole = allCollections.filter(
    collection => !collection.isPublic && collection.canManageByRole
  )
  const collectionsForUser = allCollections.filter(
    collection => !collection.isPublic && collection.canManageByUser
  )
  const assignedCollections = hasManageAllPermission
    ? allCollections.filter(collection => !collection.isPublic)
    : [
        ...collectionsForRole,
        ...collectionsForUser.filter(collection => !collection.canManageByRole)
      ]

  return (
    <>
      <Tabs
        tabs={Object.values(COLLECTION_TABS).map(tab => ({ label: tab }))}
        activeTab={activeTab}
        setActiveTab={setActiveTab as Dispatch<SetStateAction<string>>}
      />
      {
        {
          [COLLECTION_TABS.PUBLIC]: <CollectionsGrid collections={publicCollections} />,
          [COLLECTION_TABS.ASSIGNED]: <CollectionsGrid collections={assignedCollections} />
        }[activeTab]
      }
    </>
  )
}
